"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutServicesByServcieNoValidation = exports.PostJobDutyValidation = exports.PutJobDutyValidation = exports.PostDepartmentsValidation = exports.PutDepartmentsValidation = exports.deleteAdminsServiceAdminNoValidation = exports.putAdminsPasswordValidation = exports.putAdminsPasswordByKeyValidation = exports.postAdminPartnerValidation = void 0;
var utils_1 = require("./utils");
// [Admin]
function postAdminPartnerValidation(postAdminsPartnerRequest) {
    var errorList = [];
    var data = postAdminsPartnerRequest.data;
    if (!data.adminName) {
        utils_1.addErrorList(errorList, 'adminName', 'ADMIN_NEW_POST_PARTNER_ADMINNAME_ERROR');
    }
    if (!data.adminRole) {
        utils_1.addErrorList(errorList, 'adminRole', 'ADMIN_NEW_POST_PARTNER_ADMINROLE_ERROR');
    }
    if (!data.adminEmail) {
        utils_1.addErrorList(errorList, 'adminEmail', 'ADMIN_NEW_POST_PARTNER_ADMINEMAIL_ERROR');
    }
    if (utils_1.checkName(data.adminName)) {
        utils_1.addErrorList(errorList, 'adminName', 'ADMIN_NEW_POST_PARTNER_ADMINENAME_CHECK_ERROR');
    }
    if (!utils_1.checkEmail(data.adminEmail)) {
        utils_1.addErrorList(errorList, 'adminEmail', 'ADMIN_NEW_POST_PARTNER_ADMINEMAIL_CHECK_ERROR');
    }
    return errorList;
}
exports.postAdminPartnerValidation = postAdminPartnerValidation;
function putAdminsPasswordByKeyValidation(putAdminsPasswordByKeyRequest) {
    var errorList = [];
    var data = putAdminsPasswordByKeyRequest.data;
    if (!data.newPassword) {
        utils_1.addErrorList(errorList, 'newPassword', 'PASSWORD_CHANGE_PUT_ADMINS_PASSWORD_NEWPASSWORD_ERROR');
    }
    if (!utils_1.checkPassword(data.newPassword)) {
        utils_1.addErrorList(errorList, 'checkNewPassword', 'PASSWORD_CHANGE_PUT_ADMINS_PASSWORD_NEWPASSWORD_FORM_ERROR');
    }
    return errorList;
}
exports.putAdminsPasswordByKeyValidation = putAdminsPasswordByKeyValidation;
function putAdminsPasswordValidation(putAdminsPasswordRequest) {
    var errorList = [];
    var data = putAdminsPasswordRequest.data;
    if (!data.currentPassword) {
        utils_1.addErrorList(errorList, 'currentPassword', 'PASSWORD_CHANGE_POST_ADMINS_PASSWORD_CURRENTPASSWORD_ERROR');
    }
    if (!data.newPassword) {
        utils_1.addErrorList(errorList, 'newPassword', 'PASSWORD_CHANGE_PUT_ADMINS_PASSWORD_NEWPASSWORD_ERROR');
    }
    if (!utils_1.checkPassword(data.newPassword)) {
        utils_1.addErrorList(errorList, 'checkNewPassword', 'PASSWORD_CHANGE_PUT_ADMINS_PASSWORD_NEWPASSWORD_FORM_ERROR');
    }
    return errorList;
}
exports.putAdminsPasswordValidation = putAdminsPasswordValidation;
function deleteAdminsServiceAdminNoValidation(deleteAdminsServiceRequest) {
    var errorList = [];
    var pathParams = deleteAdminsServiceRequest.pathParams;
    if (!pathParams.adminNo) {
        utils_1.addErrorList(errorList, 'adminNo', 'DELETE_ADMINS_SERVICE_ADMINNO_ERROR');
    }
    return errorList;
}
exports.deleteAdminsServiceAdminNoValidation = deleteAdminsServiceAdminNoValidation;
// [Contract]
// [Department]
function PutDepartmentsValidation(PutDepartmentsRequest) {
    var errorList = [];
    var pathParams = PutDepartmentsRequest.pathParams;
    var data = PutDepartmentsRequest.data;
    if (!data.departmentName) {
        utils_1.addErrorList(errorList, 'departmentName', 'NAME_ERROR');
    }
    return errorList;
}
exports.PutDepartmentsValidation = PutDepartmentsValidation;
function PostDepartmentsValidation(PostDepartmentsRequest) {
    var errorList = [];
    var data = PostDepartmentsRequest.data;
    if (!data.departmentName) {
        utils_1.addErrorList(errorList, 'departmentName', 'NAME_ERROR');
    }
    return errorList;
}
exports.PostDepartmentsValidation = PostDepartmentsValidation;
// [Internal Admin]
// [Internal Contract]
// [Internal Mall]
// [Internal Partner]
// [Internal Service]
// [Job Duty]
function PutJobDutyValidation(PutJobDutyRequest) {
    var errorList = [];
    var pathParams = PutJobDutyRequest.pathParams;
    var data = PutJobDutyRequest.data;
    if (!data.jobDutyName) {
        utils_1.addErrorList(errorList, 'jobDutyName', 'NAME_ERROR2');
    }
    return errorList;
}
exports.PutJobDutyValidation = PutJobDutyValidation;
function PostJobDutyValidation(PostJobDutyRequest) {
    var errorList = [];
    var data = PostJobDutyRequest.data;
    if (!data.jobDutyName) {
        utils_1.addErrorList(errorList, 'jobDutyName', 'NAME_ERROR2');
    }
    return errorList;
}
exports.PostJobDutyValidation = PostJobDutyValidation;
// [Mall]
// [Partner]
// [Privacy]
// [Service]
function PutServicesByServcieNoValidation(putServicesByServcieNoRequest) {
    var errorList = [];
    var data = putServicesByServcieNoRequest.data;
    if (!data.representative.name) {
        utils_1.addErrorList(errorList, 'representative.name', 'SERVICE_INFO_ALERT_4');
    }
    if (!data.business.type) {
        utils_1.addErrorList(errorList, 'business.type', 'SERVICE_INFO_ALERT_5');
    }
    if (!data.business.condition) {
        utils_1.addErrorList(errorList, 'business.condition', 'SERVICE_INFO_ALERT_6');
    }
    if (!data.representative.phoneNo) {
        utils_1.addErrorList(errorList, 'representative.phoneNo', 'SERVICE_INFO_ALERT_7');
    }
    if (!data.representative.email) {
        utils_1.addErrorList(errorList, 'representative.email', 'SERVICE_INFO_ALERT_8');
    }
    if (!data.address.zipCode || !data.address.address || !data.address.jibun) {
        utils_1.addErrorList(errorList, 'address', 'SERVICE_INFO_ALERT_10');
    }
    return errorList;
}
exports.PutServicesByServcieNoValidation = PutServicesByServcieNoValidation;
